// src/components/modals/ReprintModal.jsx
import React from "react";
import Ticket from "../../../components/Ticket"; // ajusta la ruta según donde tengas tu Ticket.js

export default function ReprintModal({ show, invoice, onClose }) {
  if (!show || !invoice) return null;

  return (
    <div
      className="reprint-modal-overlay"
      style={{
        position: "fixed",
        top: 0, left: 0,
        width: "100vw", height: "100vh",
        backgroundColor: "rgba(0,0,0,0.6)",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        className="reprint-modal-content"
        style={{
          background: "white",
          borderRadius: "8px",
          padding: "16px",
          maxWidth: "420px",
          width: "100%",
          maxHeight: "90vh",
          overflowY: "auto",
          position: "relative",
        }}
      >
        <style>
          {`
            @media print {
              .reprint-modal-overlay {
                position: static !important;
                background: none !important;
                width: auto !important;
                height: auto !important;
                display: block !important;
              }
              .reprint-modal-content {
                position: static !important;
                max-width: none !important;
                max-height: none !important;
                overflow: visible !important;
                padding: 0 !important;
                border-radius: 0 !important;
              }
            }
          `}
        </style>

        {/* Botón cerrar */}
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: "10px", right: "10px",
            background: "#ef4444",
            color: "white",
            border: "none",
            borderRadius: "50%",
            width: "30px", height: "30px",
            cursor: "pointer",
            fontSize: "16px",
            zIndex: 10,
          }}
        >
          ✕
        </button>

        {/* Reutilizamos el Ticket existente */}
        <Ticket
          invoice={invoice}
          onAfterPrint={onClose}
        />
      </div>
    </div>
  );
}